import {UseQueryReturnType} from '@tanstack/vue-query'
import {Ref} from 'vue'

import {LineChartModel} from '~/types/model/analytics.model'
import {ITab} from '~/types/tab.type'
import type {ValueOf} from '~/types/value-of'

export const IAnalyticsPeriod = {
  D7: 'D7',
  M1: 'M1',
  M6: 'M6',
  YTD: 'YTD',
  Y1: 'Y1',
  ALL: 'ALL',
  SELECTOR: 'selector',
} as const
export type IAnalyticsPeriod = ValueOf<typeof IAnalyticsPeriod>

export const IAnalyticsInterval = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  // QUARTER: 'QUARTER',
} as const
export type IAnalyticsInterval = ValueOf<typeof IAnalyticsInterval>

/**
 * @description
 * from, to는 yyyy-mm-dd 형식으로 입력
 */
export type IAnalyticsParam = {
  period: IAnalyticsPeriod
  from?: string
  to?: string
  interval?: IAnalyticsInterval
}

export type IAnalyticsChartInfoOption = {
  api: (params: Ref<IAnalyticsParam>, enabled?: Ref<boolean>) => UseQueryReturnType<LineChartModel, unknown>
  periodList?: Array<ITab<string>>
  intervalList?: Array<ITab<string>>
  singleSelect?: boolean
  yMax?: number
  yTickAmount?: number
  unit?: string
  allowDecimals?: boolean
}